import styled from '@emotion/styled'
export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`

export const AdminLoginCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  padding: 40px;
  border-radius: 10px;
  width: 360px;
`

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  color: ${(props: any) => props.theme.colors.primary};
`

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
`

export const ErrorText = styled.div`
  color: red;
  font-size: 13px;
  margin-bottom: 10px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: ${(props: any) => props.theme.colors.white};
`
export const Logo = styled.img``
